import { defaultDataIdFromObject, InMemoryCache, makeVar } from '@apollo/client';
import { gqlCountryEnum as countryType, gqlPurchaseSubscriptionInput, gqlSubscription } from '@minecraft.graphql-types';

// Default country if no Cloudfront Header exists
export const userCountryFromHeaders = makeVar(countryType.US);

export const billingSuccessDetailsVar = makeVar({
  invoiceId: '',
  lastFour: '',
  cardType: '',
  email: '',
  paymentType: '',
  artistId: '',
});

export const subscriptionDetailsVar = makeVar<{
  subscriptionPlanCode: gqlSubscription['plan']['billingCode'];
  subscriptionPlanId?: gqlSubscription['plan']['id'];
  subscriptionPromoCodes?: gqlPurchaseSubscriptionInput['couponCode'][];
  isRenewal?: boolean;
}>({
  subscriptionPlanCode: null,
  subscriptionPlanId: null,
  subscriptionPromoCodes: [],
  isRenewal: false,
});

export const profileAccessTokenVar = makeVar({
  profileAccessTokenId: null,
  organizationId: null,
  artistId: null,
  profileId: null,
});

export const invitationTokenVar = makeVar({
  invitationTokenId: null,
  isCompleted: false,
  isExpired: false,
});

export const forwardRequestInfoVar = makeVar({
  forwardRequestName: null,
  forwardRequestToken: null,
});

export const emailTokenVar = makeVar({
  verifyEmailToken: null,
  message: null,
});

export const cacheConfig = {
  typePolicies: {
    Query: {
      fields: {
        billingSuccessDetails: {
          read() {
            return billingSuccessDetailsVar();
          },
          merge: true,
        },
        subscription: {
          read() {
            return subscriptionDetailsVar();
          },
          merge: true,
        },
        profileAccessToken: {
          read() {
            return profileAccessTokenVar();
          },
        },
        invitationToken: {
          read() {
            return invitationTokenVar();
          },
        },
        forwardRequestInfo: {
          read() {
            return forwardRequestInfoVar();
          },
        },
        emailToken: {
          read() {
            return emailTokenVar();
          },
        },
        getMediaByArtist: {
          merge(_existing = [], incoming = []) {
            return incoming;
          },
        },
        getSubmissionByRoleProfile: {
          merge(_existing = [], incoming = []) {
            return incoming;
          },
        },
      },
    },
    Role: {
      fields: {
        projectUnion: {
          merge(_existing, incoming) {
            return incoming;
          },
        },
      },
    },
    Account: {
      fields: {
        billingInfo: {
          merge: true,
        },
      },
    },
  },
  dataIdFromObject: (object) => {
    // eslint-disable-next-line no-underscore-dangle
    switch (object.__typename) {
      case 'PlanModel':
        return `${object['id']}${object['currency']?.id}${object['price']}${object['code']}`;
      case 'BillingItemModel':
        return `${object['id']}${object['price']}${object['code']}${object['availableCredit']}`;
      default:
        return defaultDataIdFromObject(object);
    }
  },
};

export default new InMemoryCache(cacheConfig);
